// @ts-nocheck
// biome-ignore-all lint: copied from kimyoDUv2 template and adapted for this app.
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function Layout() {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	useEffect(() => {
		const closeOnDesktop = () => {
			if (window.innerWidth > 900) {
				setIsSidebarOpen(false);
			}
		};

		window.addEventListener("resize", closeOnDesktop);
		return () => window.removeEventListener("resize", closeOnDesktop);
	}, []);

	return (
		<div
			className="app-shell"
			style={{
				background: "var(--app-page-bg)",
				minHeight: "100vh",
				fontFamily: "'Inter', sans-serif",
				transition: "background 0.2s ease",
			}}
		>
			<Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
			<div className="app-content" style={{ marginLeft: "var(--app-sidebar-offset, 220px)" }}>
				<Topbar onMenuClick={() => setIsSidebarOpen(true)} />
				<main
					className="app-main"
					style={{
						padding: "var(--app-main-padding, 24px)",
						minHeight: "var(--app-main-min-height, calc(100vh - 60px))",
					}}
				>
					<Outlet />
				</main>
			</div>
		</div>
	);
}
